<template>
  <div class="results">
    <div>
      <!--      <div class="item success">-->
      <!--        <span>Line Discounts Offered</span>-->
      <!--        <span>{{ formatPrice(lineDiscountsOffered) }}</span>-->
      <!--      </div>-->
      <!--      <div class="item success">-->
      <!--        <span>Lump Sum Discounts Offered</span>-->
      <!--        <span>{{ formatPrice(lumpsumDiscountsOffered) }}</span>-->
      <!--      </div>-->
      <!--      <div class="item success">-->
      <!--        <span>SC/PWD Discount ?</span>-->
      <!--        <span>{{ formatPrice(scPwdDiscount) }}</span>-->
      <!--      </div>-->
      <div class="item">
        <span>Discount</span>
        <span class="num">{{ formatPrice(discount) }}</span>
      </div>
      <div class="item">
        <span>Other Revenue Charges</span>
        <span class="num">{{ formatPrice(otherRevenueCharges) }}</span>
      </div>
      <div class="item">
        <span>Non Revenue Charges</span>
        <span class="num">{{ formatPrice(nonRevenueCharges) }}</span>
      </div>
      <div class="item">
        <span>Deposits Taken</span>
        <span class="num">{{ formatPrice(depositToken) }}</span>
      </div>
      <div class="item orange">
        <span>VATable Amount</span>
        <span class="num">{{ formatPrice(vatableAmount) }}</span>
      </div>
      <div class="item orange">
        <span>VAT-Exempt Amount</span>
        <span class="num">{{ formatPrice(vatExAmount) }}</span>
      </div>
      <div class="item orange">
        <span>Zero Rated Amount</span>
        <span class="num">{{ formatPrice(zeroRatedAmount) }}</span>
      </div>
      <div class="item orange">
        <span>VAT Amount</span>
        <span class="num">{{ formatPrice(vatAmount) }}</span>
      </div>
      <div class="item orange">
        <span>Total Amount (VAT Inclusive)</span>
        <span class="num">{{ formatPrice(totalAmountVatInclusinve) }}</span>
      </div>
      <div v-if="transactionNo">
        <!-- <el-button :disabled="false" type="primary" size="mini" style="width: 100%;" @click="openJournalModal">View Transaction</el-button> -->
        <div @click="openJournalModal" class="btnViewTransaction">View Transaction</div>
      </div>
    </div>
    <div>
      <!-- <div v-if="appliedUnderOverPMTBal > 0" class="item grey">
        <span>Less: Over Pmt Applied</span>
        <span>{{ formatPrice(appliedUnderOverPMTBal) }}</span>
      </div> -->
      <div class="item grey">
        <span>Amount (VAT Exclusive)</span>
        <span class="num">{{ formatPrice(amountVatExcluded) }}</span>
      </div>
      <!--      <div class="item grey">-->
      <!--        <span>Less: Total Discounts</span>-->
      <!--        <span>{{ formatPrice(lessTotalDiscounts) }}</span>-->
      <!--      </div>-->
      <!--      <div class="item grey">-->
      <!--        <span>Amount NET of Discounts</span>-->
      <!--        <span>{{ formatPrice(amountNetOfDiscounts) }}</span>-->
      <!--      </div>-->
      <div class="item grey">
        <span>Add: VAT Amount</span>
        <span class="num">{{ formatPrice(addVatAmount) }}</span>
      </div>
      <div class="item grey">
        <span>Total Amount (VAT Inclusive)</span>
        <span class="num">{{ formatPrice(totalAmountNoTax) }}</span>
      </div>
      <div class="item grey">
        <span>Less: Creditable Withholding VAT</span>
        <span class="num">{{ formatPrice(lessCreditableWithholdingVat) }}</span>
      </div>
      <div class="item grey">
        <span>Less: Creditable Withholding Tax</span>
        <span class="num">{{ formatPrice(lessCreditableWithholdingTax) }}</span>
      </div>
      <div v-if="appliedUnderOverPMTBal > 0" class="item grey">
        <span>Less: Over Pmt Applied</span>
        <span>{{ formatPrice(appliedUnderOverPMTBal) }}</span>
      </div>
      <div class="item grey bold">
        <span>Amount Owing</span>
        <span class="num">{{ formatPrice(amountOwing) }}</span>
      </div>
      <div class="item grey bold">
        <span>Received Amount</span>
        <span class="num">{{ formatPrice(receivedAmount) }}</span>
      </div>
<!--      <div class="item grey bold dots">-->
<!--        <span>Balance Owing</span>-->
<!--        <span class="num">{{ formatPrice(balanceOwing) }}</span>-->
<!--      </div>-->
      <div class="item grey bold dots">
        <span :class="{ 'tf-red': underPayment > 0 }">Client Under Payment</span>
        <span class="num" :class="{ 'tf-red': underPayment > 0 }">{{ formatPrice(underPayment) }}</span>
      </div>
      <div class="item grey bold dots">
        <span :class="{ 'tf-green': overPayment > 0 }">Client Over Payment</span>
        <span class="num" :class="{ 'tf-green': overPayment > 0 }">{{ formatPrice(overPayment) }}</span>
      </div>
    </div>
    <div v-if="currency && currency !== companyLayout.currency.code" :span="4">
      <div class="item grey prices">
        <span>{{companyLayout.currency.code}}</span>
      </div>
      <div class="item grey bold prices">
        <span class="num">{{ formatPrice(amountOwingClientCurrency) }}</span>
      </div>
      <div class="item grey bold prices">
        <span class="num">{{ formatPrice(receivedAmountClientCurrency) }}</span>
      </div>
<!--      <div class="item grey bold dots prices">-->
<!--        <span class="num">{{ formatPrice(balanceOwingClientCurrency) }}</span>-->
<!--      </div>      -->
      <div class="item grey bold dots prices">
        <span class="num">{{ formatPrice(underPaymentClientCurrency) }}</span>
      </div>
      <div class="item grey bold dots prices">
        <span class="num">{{ formatPrice(overPaymentClientCurrency) }}</span>
      </div>
    </div>

    <editJournalEntryModal :showInfo="false" ref="editJournalEntryModal"/>
  </div>
</template>

<script>
import editJournalEntryModal from '@/components/journalAndGl/editJournalEntryModal.vue'

export default {
  name: "CashReceiptResultTaxExempt",
  components: {
    editJournalEntryModal,
  },
  props: {
    transaction: {
      type: Object,
      default: () => {
        return {}
      }
    },
    transactionNo: {
      type: String,
      default: ''
    },
    appliedUnderOverPMTBal: {
      type: Number,
      default: 0
    }, // TODO +
    lineDiscountsOffered: {
      type: Number,
      default: 0
    }, // TODO +
    lumpsumDiscountsOffered: {
      type: Number,
      default: 0
    }, // TODO +
    scPwdDiscount: {
      type: Number,
      default: 0
    }, // TODO +
    otherRevenueCharges: {
      type: Number,
      default: 0
    }, // TODO +
    nonRevenueCharges: {
      type: Number,
      default: 0
    }, // TODO +
    discount: {
      type: Number,
      default: 0
    }, // TODO +
    depositToken: {
      type: Number,
      default: 0
    }, // TODO +
    vatableAmount: {
      type: Number,
      default: 0
    }, // TODO +
    vatExAmount: {
      type: Number,
      default: 0
    }, // TODO +
    zeroRatedAmount: {
      type: Number,
      default: 0
    }, // TODO +
    // addVat: {
    //   type: Number,
    //   default: 0
    // },
    vatAmount: {
      type: Number,
      default: 0
    }, // TODO +
    // totalAmount: {
    //   type: Number,
    //   default: 0
    // },
    totalAmountVatInclusinve: {
      type: Number,
      default: 0
    }, // TODO +
    currency: {
      type: String,
      default: null
    },
    amountOwingClientCurrency: {
      type: Number,
      default: 0
    },
    receivedAmountClientCurrency: {
      type: Number,
      default: 0
    },
    balanceOwingClientCurrency: {
      type: Number,
      default: 0
    },
    underPaymentClientCurrency: {
      type: Number,
      default: 0
    },
    overPaymentClientCurrency: {
      type: Number,
      default: 0
    },

    amountVatExcluded: {
      type: Number,
      default: 0
    }, // TODO +
    // lessSCPWDDiscount: {
    //   type: Number,
    //   default: 0
    // },
    lessTotalDiscounts: {
      type: Number,
      default: 0
    }, // TODO +
    // totalAmountVatInclusinve: {
    //   type: Number,
    //   default: 0
    // },
    amountNetOfDiscounts: {
      type: Number,
      default: 0
    }, // TODO +
    // amountNetVat: {
    //   type: Number,
    //   default: 0
    // },
    addVatAmount: {
      type: Number,
      default: 0
    }, // TODO +
    totalAmountNoTax: {
      type: Number,
      default: 0
    }, // TODO +
    // lessWHTax: {
    //   type: Number,
    //   default: 0
    // },
    // lessVatWHTax: {
    //   type: Number,
    //   default: 0
    // },
    lessCreditableWithholdingVat: {
      type: Number,
      default: 0
    }, // TODO +
    lessCreditableWithholdingTax: {
      type: Number,
      default: 0
    }, // TODO +
    amountOwing: {
      type: Number,
      default: 0
    }, // TODO +
    receivedAmount: {
      type: Number,
      default: 0
    }, // TODO +
    balanceOwing: {
      type: Number,
      default: 0
    }, // TODO +
    overPayment: {
      type: Number,
      default: 0
    }, // TODO +
    underPayment: {
      type: Number,
      default: 0
    } // TODO +
  },
  computed: {
    companyLayout() {
      return this.$store.state.companyLayout
    },
  },
  methods: {
    openJournalModal() {
      const rowItem = {...this.transaction}
      this.$refs['editJournalEntryModal'].openModalFromJournalEntry(rowItem)
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
  }
}
</script>

<style lang="scss" scoped>
.btnViewTransaction {
  width: 100%;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #409EFF;
  border: 1px solid #409EFF;
  color: #FFF;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: .1s;
  font-weight: 500;
  padding: 7px 15px;
  font-size: 12px;
  border-radius: 3px;
  &:focus {
    background: #66b1ff;
    border-color: #66b1ff;
    color: #FFF;
  }
  &:hover {
    background: #66b1ff;
    border-color: #66b1ff;
    color: #FFF;
  }
}
.results {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: fit-content;
  gap: 20px;
  float: right;
  .item {
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    min-width: 260px;
    padding: 6px;
    margin-bottom: 10px;
    border: 1px solid #a9a9b0;
    &.orange {
      background-color: #f5dab1;
      min-width: 250px;
      margin-left: auto;
    }
    &.success {
      background-color: #e1f3d8;
    }
    &.grey {
      background-color: #ebeef5;
    }
    &.bold {
      font-weight: bold;
    }
    &.dots {
      border: 1px dashed #a9a9b0;
    }
    &.prices {
      align-items: center;
      justify-content: center;
      text-align: center;
      min-width: 100px;
    }
    .num {
      min-width: 85px;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }
    .tf-red {
      color: #F56C6C;
    }
    .tf-green {
      color: #50b944;
    }
  }
}
</style>